import React from 'react';
import Slider from 'react-slick';
import SlickArrow from '../../../shared/SlickArrow/SlickArrow';

import './CircularCarouselSymptoms.scss';

import './CircularCarouselSymptoms.scss';
import Link from '../../../shared/Link/Link';
import SlickArrowCircleSecondary from '../../../shared/SlickArrow/SlickArrowCircleSecondary';
import { SymptomIcon } from './SymptomsIcons';

const CircularCarouselSymptoms = ({
  primaryColor,
  secondaryColor,
  symptomsData,
  coloredBackgroundCircularCarouselSymptoms,
  sliderCircleArrowsSymptoms,
  circularCarouselSymptomsVersion,
  symptomsCarouselTitle,
  circularCarouselSymptomsStyle,
  ...props
}) => {
  const settings = {
    arrows: true,
    prevArrow:
      sliderCircleArrowsSymptoms === 1 &&
      circularCarouselSymptomsVersion === 1 ? (
        <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
      ) : sliderCircleArrowsSymptoms === 1 &&
        circularCarouselSymptomsVersion === 2 ? (
        <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
      ) : sliderCircleArrowsSymptoms === 0 ? (
        <SlickArrow />
      ) : sliderCircleArrowsSymptoms === 1 &&
        circularCarouselSymptomsVersion === 3 ? (
        <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
      ) : null,
    nextArrow:
      sliderCircleArrowsSymptoms === 1 &&
      circularCarouselSymptomsVersion === 1 ? (
        <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
      ) : sliderCircleArrowsSymptoms === 1 &&
        circularCarouselSymptomsVersion === 2 ? (
        <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
      ) : sliderCircleArrowsSymptoms === 0 ? (
        <SlickArrow />
      ) : sliderCircleArrowsSymptoms === 1 &&
        circularCarouselSymptomsVersion === 3 ? (
        <SlickArrowCircleSecondary secondaryColor={secondaryColor} />
      ) : null,
    dots: false,
    customPaging: function(i) {
      return !!withThumbnails ? (
        <a />
      ) : (
        <button className="dot">{/* {i + 1} */}</button>
      );
    },
    autoplay: true,
    infinite: true,
    autoplaySpeed: 4000,
    pauseOnHover: false,
    speed: 500,
    slidesToShow: 8,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '100px',
    responsive: [
      {
        breakpoint: 1300,
        settings: { slidesToShow: 4, slidesToScroll: 1 },
      },

      { breakpoint: 992, settings: { slidesToShow: 4, slidesToScroll: 1 } },
      // { breakpoint: 768, settings: { slidesToShow: 4, slidesToScroll: 1 } },
      {
        breakpoint: 900,
        settings: { slidesToShow: 3, slidesToScroll: 1, centerPadding: '10px' },
      },
      {
        breakpoint: 400,
        settings: { slidesToShow: 2, slidesToScroll: 1, centerPadding: '10px' },
      },
      {
        breakpoint: 300,
        settings: { slidesToShow: 1, slidesToScroll: 1, centerPadding: '10px' },
      },
    ],
  };

  return (
    <div className="circular-carousel-symptoms">
      <div
        className={`container ${coloredBackgroundCircularCarouselSymptoms &&
          'colored-bg'}`}
        css={circularCarouselSymptomsStyle}
      >
        {!!symptomsCarouselTitle && (
          <div className="title-container">
            <h2>{symptomsCarouselTitle}</h2>
          </div>
        )}
        <Slider {...settings}>
          {!!symptomsData &&
            [...symptomsData, ...symptomsData, ...symptomsData]
              .filter(item => !!item.publishFarmakom)
              .map(item => (
                <div className="symptom-container">
                  <div className={`symptom-frame`}>
                    <Link
                      aria-label={`Guarda i prodotto per il sintomo ${item.name}`}
                      to={'/sintomo/' + item.slug}
                    >
                      <SymptomIcon
                        type={item.name}
                        primaryColor={primaryColor}
                        secondaryColor={secondaryColor}
                        fallbackImage={item.imageUrl}
                      />
                    </Link>
                  </div>
                  <Link
                    aria-label={`Guarda i prodotto per il sintomo ${item.name}`}
                    to={'/sintomo/' + item.slug}
                  >
                    <h3 className="symptom-subtitle">{item.name}</h3>
                  </Link>
                </div>
              ))}
        </Slider>
      </div>
    </div>
  );
};

export default CircularCarouselSymptoms;
//circularCarouselSymptomsVersion 1: "Visualizza tutti" color as primaryColor;
//circularCarouselSymptomsVersion 1: "Visualizza tutti" color as secondaryyColor;
